import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const portalModalVariants = cva(styles.modalRoot, {
  variants: {
    variant: {
      md: styles.md,
      lg: styles.lg,
      xl: styles.xl,
    },
  },
  defaultVariants: {
    variant: 'md',
  },
});
